import template from './requestInvoice.html';
import controller from './requestInvoice.controller';

let requestInvoiceComponent = {
    restrict: 'E',
    require: {
        booking: '^booking'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default requestInvoiceComponent;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/requestInvoice/requestInvoice.component.js